export enum CancelScreen {
  question = "Answer a few questions",
  gifted_credits = "Receive Gifted Credits",
  gifted_credits_granted = "Confirmed: Receive Gifted Credits",
}

export const DialogTitles = {
  [CancelScreen.question]: <>Before you go, a few questions...</>,
  [CancelScreen.gifted_credits]: <>One last gift for you! </>,
  [CancelScreen.gifted_credits_granted]: <>Credits applied! 🎉</>,
};

export type QuestionsToAsk = {
  answer: string;
  question: string;
};

export const ProCancelQuestions = [
  {
    question:
      "Did you make any personal tweaks to the pitch templates that Bento wrote for you?",
    answer: "No",
  },
  {
    question: "Did you send more than 100 pitches?",
    answer: "No",
  },
  {
    question: "Did you pitch to a mix of small and big brands?",
    answer: "No",
  },
];

export const VaCancelQuestions = [
  {
    question:
      "Did you make any personal tweaks to the pitch templates that Bento wrote for you?",
    answer: "No",
  },
  {
    question: "Did you pitch for 3+ months?",
    answer: "No",
  },
  {
    question: "Did you pitch to 3+ niches?",
    answer: "No",
  },
];
